export function normalizeNote(note: string): string | null {
    const trimmedNote = note.trim();

    return trimmedNote.length ? trimmedNote : null;
}
